module.exports = __webpack_public_path__ + "img/jiankangguanli_image_zhuyi.ce507319.png";